import { randomBytes } from "@noble/hashes/utils.js";

const STORAGE_KEY = "gummiworm:guest-ws-identity";

// Used only to open the market-data websocket when no wallet is connected.
// Never treated as a real account: the server has no deposits under this
// hash, so `ledgerView.account` stays null and all wallet-owner gating
// (myAccountId, trade submission, withdrawals) is unaffected.
export const ensureGuestWsIdentity = (): string => {
  const existing = window.localStorage.getItem(STORAGE_KEY);
  if (existing) return existing;

  const identity = randomBytes(28).toHex();
  window.localStorage.setItem(STORAGE_KEY, identity);
  return identity;
};
